module.exports = {
	BitmapChar: require("./BitmapChar").default,
	BitmapCharLocation: require("./BitmapCharLocation").default,
	BitmapFont: require("./BitmapFont").default,
	BitmapFontType: require("./BitmapFontType").default,
	ITextCompositor: require("./ITextCompositor").default,
	TextField: require("./TextField").default,
	TextFieldAutoSize: require("./TextFieldAutoSize").default,
	TextFormat: require("./TextFormat").default,
	TextOptions: require("./TextOptions").default,
	TrueTypeCompositor: require("./TrueTypeCompositor").default,
}


//////////////////
// WEBPACK FOOTER
// ./lib/starling/text/index.js
// module id = 330
// module chunks = 0